<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
  <path fill-rule="evenodd" d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Zm6.175-14.293a1 1 0 0 0-1.414-1.414l-6.1 6.1-2.454-2.455a1 1 0 0 0-1.414 1.414l3.161 3.162a1 1 0 0 0 1.414 0l6.807-6.807Z"/>
</svg>
